import {Component, inject, OnInit} from '@angular/core';
import {
    HealthChartConfiguration, HealthChartPeriod,
    HealthDataType,
} from '../../../../../../models/health.models';
import {NavigationService} from '../../../../../../services/navigation.service';
import {HealthDataPageComponent} from '../../../../../../components/health-data-page/health-data-page.component';
import {dataType} from "terra-api/lib/esm/API/Data";

@Component({
    selector: 'app-body-fat-page',
    standalone: true,
    imports: [HealthDataPageComponent],
    templateUrl: './body-fat-page.component.html',
    styleUrl: './body-fat-page.component.css',
})
export default class BodyFatPageComponent implements OnInit {
    #navigationService = inject(NavigationService);

    healthDataLabel = 'Percentuale Massa Grassa';
    chartLabel = 'Percentuale Massa Grassa';
    chartConfiguration: HealthChartConfiguration = {
        [HealthChartPeriod.day]: 'bubble',
        [HealthChartPeriod.week]: 'line',
        [HealthChartPeriod.month]: 'line',
    }
    supportedPeriods: HealthChartPeriod[] = [HealthChartPeriod.week, HealthChartPeriod.month];
    heightHealthDataType = HealthDataType.BODY_FAT_PERCENTAGE;
    hasTwoDecimals = true;
    payloadTypes: dataType[] = ['body'];

    ngOnInit(): void {
        this.#navigationService.saveCurrentRoute();
    }
}
